import { esimPublicApiClient } from "../api/EsimApiClient";

export async function fetchPrivacyPolicy(language = null) {
  const { data } = await esimPublicApiClient.get("/legal/privacy-policy", {
    params: language ? { language } : undefined,
  });
  return data;
}

export async function fetchTermsOfService(language = null) {
  const { data } = await esimPublicApiClient.get("/legal/terms-and-conditions", {
    params: language ? { language } : undefined,
  });
  return data;
}
